import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面未找到 - 缘之空影视资讯平台",
    description: "你访问的页面不存在，请返回缘之空首页继续浏览影视资讯与剧情介绍。",
  });

  return (
    <div className="w-full px-4 md:px-6 py-24 flex flex-col items-center text-center">
      <p className="font-heading text-6xl md:text-7xl font-bold text-primary-500 mb-4">404</p>
      <h1 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">页面走丢了</h1>
      <p className="text-sm text-foreground-500 max-w-md mb-7">
        你访问的页面不存在或已被移动，可以返回首页，或去影视分类页继续探索感兴趣的作品。
      </p>
      <div className="flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
        <Link
          to="/category/movie"
          className="inline-flex items-center justify-center gap-1.5 px-5 py-2.5 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 transition-colors whitespace-nowrap"
        >
          <i className="ri-film-line"></i>
          浏览影视分类
        </Link>
      </div>
    </div>
  );
}